<template>
  <f7-card class="post-skeleton-card">
    <!-- Card Header -->
    <f7-card-header class="skeleton-header">
      <div class="skeleton-avatar">
        <f7-skeleton-block
          tag="div"
          width="40px"
          height="40px"
          border-radius="50%"
          effect="wave"
        ></f7-skeleton-block>
      </div>
      <div class="skeleton-header-content">
        <f7-skeleton-block
          tag="div"
          width="120px"
          height="16px"
          border-radius="4px"
          effect="wave"
        ></f7-skeleton-block>
        <f7-skeleton-block
          tag="div"
          width="80px"
          height="12px"
          border-radius="4px"
          effect="wave"
          class="skeleton-subtitle"
        ></f7-skeleton-block>
      </div>
    </f7-card-header>

    <!-- Card Content -->
    <f7-card-content class="skeleton-content">
      <!-- Text Lines -->
      <div class="skeleton-text-lines">
        <f7-skeleton-block
          tag="div"
          width="100%"
          height="14px"
          border-radius="4px"
          effect="wave"
        ></f7-skeleton-block>
        <f7-skeleton-block
          tag="div"
          width="95%"
          height="14px"
          border-radius="4px"
          effect="wave"
        ></f7-skeleton-block>
        <f7-skeleton-block
          tag="div"
          width="85%"
          height="14px"
          border-radius="4px"
          effect="wave"
        ></f7-skeleton-block>
      </div>

      <!-- Media Placeholder -->
      <div class="skeleton-media">
        <f7-skeleton-block
          tag="div"
          width="100%"
          height="280px"
          border-radius="12px"
          effect="wave"
        ></f7-skeleton-block>
      </div>

      <!-- Categories/Tags -->
      <div class="skeleton-tags">
        <f7-skeleton-block
          tag="div"
          width="60px"
          height="24px"
          border-radius="12px"
          effect="wave"
        ></f7-skeleton-block>
        <f7-skeleton-block
          tag="div"
          width="80px"
          height="24px"
          border-radius="12px"
          effect="wave"
        ></f7-skeleton-block>
      </div>
    </f7-card-content>

    <!-- Card Footer -->
    <f7-card-footer class="skeleton-footer">
      <div class="skeleton-footer-actions">
        <f7-skeleton-block
          tag="div"
          width="60px"
          height="16px"
          border-radius="4px"
          effect="wave"
        ></f7-skeleton-block>
        <f7-skeleton-block
          tag="div"
          width="60px"
          height="16px"
          border-radius="4px"
          effect="wave"
        ></f7-skeleton-block>
      </div>
      <f7-skeleton-block
        tag="div"
        width="32px"
        height="32px"
        border-radius="50%"
        effect="wave"
      ></f7-skeleton-block>
    </f7-card-footer>
  </f7-card>
</template>

<script setup>
// No props or logic needed - pure presentation component
</script>

<style scoped>
.post-skeleton-card {
  margin: 0 16px 16px;
  --f7-card-margin-horizontal: 0;
}

.skeleton-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--f7-card-outline-border-color, #e5e7eb);
}

.dark .skeleton-header {
  border-bottom-color: var(--f7-color-gray-700, #374151);
}

.skeleton-avatar {
  flex-shrink: 0;
}

.skeleton-header-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-subtitle {
  margin-top: 4px;
}

.skeleton-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.skeleton-text-lines {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-media {
  width: 100%;
}

.skeleton-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.skeleton-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--f7-card-outline-border-color, #e5e7eb);
}

.dark .skeleton-footer {
  border-top-color: var(--f7-color-gray-700, #374151);
}

.skeleton-footer-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

/* Ensure skeleton blocks inherit proper colors */
.post-skeleton-card :deep(.skeleton-block) {
  background-color: var(--f7-color-gray-200, #e5e7eb);
}

.dark .post-skeleton-card :deep(.skeleton-block) {
  background-color: var(--f7-color-gray-700, #374151);
}

/* Animation optimization for mobile */
@media (prefers-reduced-motion: reduce) {
  .post-skeleton-card :deep(.skeleton-effect-wave::before) {
    animation: none;
  }
}
</style>
